export default Object.freeze({
  CUSTOMER_PROFILE: 'customer',
  CONVERSATION: 'conversation',
  TASK: 'task',
  USER: 'user',
});
